import { ListingArticlesBlog } from '@components/listing-articles-blog/models';
import { Block } from '@shared/models';

export const listingArticlesBlogMock = (
  blogType: 'b2b' | 'b2c',
  level2Category?: string
): Block<ListingArticlesBlog> => ({
  type: 'listing-articles-blog',
  data: {
    blogType,
    ...(level2Category && { level2Category }),
    featuredArticles: {
      title: 'Les sujets du moment',
      description: 'Découvrez les articles les plus appréciés des utilisateurs du blog',
    },
  },
});
